import React from "react";
import "./index.css";
import NuJobsSidebar from "../nujobsSidebar";
import { Outlet } from "react-router-dom"; // Removed unused imports
import NujobsHeader from "../nujobsheader";
import Breadcrumbs from "../../breadcrumb/breadcrumbs";

function NuJobsTransactions({ hideSidebar, hideHeader = false }) {
  return (
    <div className="">
      {!hideHeader && <NujobsHeader />}
      <div className="row nuJobsrowdesign">
        {!hideSidebar && (
          <div className="nujobscol-3">
            <NuJobsSidebar />
          </div>
        )}

        <div
          className={
            hideSidebar ? "nujobsfullWidth nujobsbodyPart" : "nujobscol-9"
          }
        >
          {!hideSidebar && <Breadcrumbs />}
          <>
            <Outlet />
          </>
        </div>
      </div>
    </div>
  );
}

export default NuJobsTransactions;
